import React from 'react';
import { WorkStationCheckinController } from './WorkStationCheckinController';
import { WorkStationInactivityController } from './WorkStationInactivityController';
import { useActivityWatcher } from '../../hooks/useActivityWatcher';

const WorkStationEventsController = () => {
  const { lastActivityDate } = useActivityWatcher();

  return (
    <>
      <WorkStationCheckinController />
      <WorkStationInactivityController lastActivityDate={lastActivityDate} />
    </>
  );
};

export { WorkStationEventsController };
